import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { App, Image, Space, Spin } from 'antd';
import config from 'config';
import { encodeToBase64 } from '@medicusunion/front-utils';
import axios from 'axios';

import {
  FileTypesEnum,
  downloadFileFromUrl,
  getFileIcon,
  getFileTypeName
} from 'utils/file';
import { tokenStorage, refreshTokenStorage } from 'utils/storage';
import { instance } from 'utils/api';

interface IProps {
  value: string;
  patientId?: string | null;
}

const DownloadFile: FC<IProps> = ({ value, patientId }) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const [isLoading, setLoading] = useState(false);

  const downloadFile = async () => {
    try {
      setLoading(true);
      const res = await instance.get(
        `storage/file/url/${value}?user_id=${patientId}`
      );

      const { url } = res.data.data;

      downloadFileFromUrl(url, value);
    } catch (error) {
      if (axios.isAxiosError(error) && error?.response?.data) {
        message.error(error.response.data.message || 'Something went wrong');
      }
    } finally {
      setLoading(false);
    }
  };

  const fileType = getFileTypeName(value);
  const isDCM =
    fileType === FileTypesEnum.dcm || fileType === FileTypesEnum.zip;

  const token = encodeToBase64(tokenStorage.get());
  const refreshToken = encodeToBase64(refreshTokenStorage.get());

  return (
    <Space style={{ width: '100%', justifyContent: 'space-between' }}>
      <Space>
        <Image
          src={getFileIcon(getFileTypeName(value))}
          width={32}
          preview={false}
          style={{ paddingRight: 8 }}
        />
        {isLoading ? (
          <Spin size="small" />
        ) : (
          <a onClick={downloadFile} style={{ marginLeft: 4 }}>
            {value}
          </a>
        )}
      </Space>
      {isDCM && (
        <div style={{ padding: '0 8px' }}>
          <a
            href={`${config.viewer_url}?t=${token}&r=${refreshToken}=&file=${value}&patientId=${patientId}`}
            target="_blank"
            rel="noreferrer"
          >
            {t('appointments_details.open_in_viewer')}
          </a>
        </div>
      )}
    </Space>
  );
};

export default DownloadFile;
